import React from 'react';
import { Icon } from '../Icons';

export const CopySucces = () => {
  return (
    <span className="f13 fw3 grass-green bg-grass-green-10 br12 pv4 ph12 ba flex items-center">
      Copiado <Icon name="SvgIconCheck" height={12} width={12} className="ml8" />
    </span>
  );
};
